import PropTypes from 'prop-types';

export const LatLngShape = PropTypes.shape({
  lat: PropTypes.number.isRequired,
  lng: PropTypes.number.isRequired,
});

export const PaddingShape = PropTypes.shape({
  bottom: PropTypes.number.isRequired,
  left: PropTypes.number.isRequired,
  right: PropTypes.number.isRequired,
  top: PropTypes.number.isRequired,
});

export const PinShape = PropTypes.shape({
  image: PropTypes.string.isRequired,
  lat: PropTypes.number.isRequired,
  lon: PropTypes.number.isRequired,
  restaurantId: PropTypes.string.isRequired,
  tooltipText: PropTypes.string.isRequired,
});
